(function () {
  var stickyThreshold = 20;
  var lastStickyState = null;
  var lastHeaderTop = null;
  var ticking = false;

  function getAnnouncement() {
    return document.querySelector('.announcement-bar-section');
  }

  function getAnnouncementBar() {
    return document.querySelector('.utility-bar, .announcement-bar');
  }

  function updateAnnouncementVisibility(isSticky) {
    var announcement = getAnnouncement();
    if (!announcement) return;

    announcement.classList.toggle('chef-announcement-hidden', isSticky);
    if (isSticky) {
      announcement.setAttribute('aria-hidden', 'true');
    } else {
      announcement.removeAttribute('aria-hidden');
    }
  }

  function updateHeaderOffset() {
    var bar = getAnnouncementBar();
    var height = window.scrollY > stickyThreshold ? 0 : bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    var value = height + 'px';

    if (value === lastHeaderTop) return;
    document.documentElement.style.setProperty('--chef-header-top', value);
    lastHeaderTop = value;
  }

  function updateHeaderState() {
    var isSticky = window.scrollY > stickyThreshold;

    if (isSticky !== lastStickyState) {
      document.documentElement.classList.toggle('chef-header-is-scrolled', isSticky);
      document.documentElement.classList.toggle('chef-header-is-sticky', isSticky);
      updateAnnouncementVisibility(isSticky);
      lastStickyState = isSticky;
    }

    updateHeaderOffset();
  }

  function requestHeaderUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(function () {
      updateHeaderState();
      ticking = false;
    });
  }

  updateHeaderOffset();
  updateHeaderState();
  window.addEventListener('resize', requestHeaderUpdate);
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
})();
